<!-- 用于展示改变后的值和改变前的值 -->

<template>
    <span>
        <span>{{ item ? item.current : '' }}</span>
        <template v-if="item.change">
            <span>
                <span>---></span>
                <span style="margin-left: 10px;" class="color-red">{{ item.modify }}</span>
            </span>
        </template>
    </span>
</template>

<script>
export default {
    props: {
        item: {
            default: () => new Object()
        }
    }
};
</script>
